<template>
  <avs-card>
    <template v-slot:title>
      <v-tabs
        background-color="bgCard"
        centered
        color="accent"
        show-arrows
        :value="value"
        @change="onTabChange"
      >
        <slot name="tabs"></slot>
      </v-tabs>
    </template>

    <template v-slot:content>
      <v-card-text class="pt-2">
        <v-tabs-items
          v-if="!loading"
          class="bgCard"
          :value="value"
          @change="onTabChange"
        >
          <slot name="items"></slot>
        </v-tabs-items>
      </v-card-text>
    </template>
  </avs-card>
</template>

<script>
export default {
  name: "AvsTabs",
  props: {
    value: { type: Number, default: 0 },
    loading: { type: Boolean, default: false }
  },
  methods: {
    onTabChange(newValue) {
      this.$emit("input", newValue)
    }
  }
}
</script>
